import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const NotFound = lazy(
  () => import('./NotFound.eager').then(mod => ({default: mod.NotFound})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
